import { render, staticRenderFns } from "./OutgoingCard.vue?vue&type=template&id=136d8b76&scoped=true"
import script from "./OutgoingCard.vue?vue&type=script&lang=js"
export * from "./OutgoingCard.vue?vue&type=script&lang=js"
import style0 from "./OutgoingCard.vue?vue&type=style&index=0&id=136d8b76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d8b76",
  null
  
)

export default component.exports